module.exports = __webpack_public_path__ + "static/media/nav-trackers-white.5c004bfd.svg";